import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import AdoptionImportTab from '../../components/body/receiver/AdoptionImportTab';
import AdoptionImportReportsTab from '../../components/body/receiver/AdoptionImportReportsTab';

const { Content } = Layout;

const AdoptionImportRoutes = () => (
  <Content className="bg-gray-100" style={{ minHeight: '100vh' }}>
    <Routes>
      <Route path="" element={<Navigate to="import" replace />} />
      <Route path="import" element={<AdoptionImportTab />} />
      <Route path="import-reports" element={<AdoptionImportReportsTab />} />
    </Routes>
  </Content>
);

export default AdoptionImportRoutes;
